import { NgModule } from "@angular/core";
import { LoggerService } from "./logger/logger-service";
import { ViewDataService } from "./wa-services/view-data-service";
import { EnvironmentService } from "./wa-services/environment-service";
import { WaHelperService } from "./wa-services/wa-helper-service";
import { MemStorageService } from "./wa-services/mem-storage.service";
import { DataFetchService } from "./wa-services/data-fetch-service";
import { FactoryService } from "./wa-services/factory-service";
import { ParamBuilderService } from "./wa-services/param-builder-service";
import { DatabaseService } from "./wa-services/database-service";
import { AthletesDatabasePouchDbService } from "./wa-services/athletes-database.service";
import { FormsModule } from "@angular/forms";
import { ComponentsModule } from "./components/components/components.module";
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [ComponentsModule, FormsModule, HttpClientModule],
  providers: [
    LoggerService,
    ViewDataService,
    WaHelperService,
    MemStorageService,
    EnvironmentService,
    DataFetchService,
    FactoryService,
    ParamBuilderService,
    DatabaseService,
    AthletesDatabasePouchDbService
  ],
  exports: [ComponentsModule, HttpClientModule]
})
export class CoreModule { }
